"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.walletsPath = exports.walletDetailPath = exports.subNavItems = exports.routesArray = exports.mainNavOptions = void 0;
var _react = _interopRequireDefault(require("react"));
var _load = _interopRequireDefault(require("../hocs/load"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var FixedLeftFluidLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/FixedLeftFluidLayout/FixedLeftFluidLayout'));
  });
});
var BalancesMenuContainer = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/BalancesMenu/BalanceMenuContainer'));
  });
});
var WalletDetailsBackButtonComponent = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/WalletDetails/WalletDetailsBackButtonComponent'));
  });
});
var DualHeaderDashboardLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/DualHeaderLayouts/DualHeaderDashboardLayout'));
  });
});
var SubNavComponent = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/SubNavRow/SubNavRowComponent'));
  });
});
var NotificationsList = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/Notifications'));
  });
}, {
  render: function render(loaded, props) {
    return /*#__PURE__*/_react["default"].createElement(loaded.Notifications, props);
  }
});
var TradingLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/TradingLayout/TradingLayoutContainer'));
  });
});
var BalancesListLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/BalancesListLayout/BalancesListLayout'));
  });
});
var RecentActivityContainer = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/RecentActivity'));
  });
});
var SingleFluidHeaderFixedContentLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/SingleFluidHeaderFixedContent/SingleFluidHeaderFixedContent'));
  });
});
var ComponentRowSingle = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/ComponentRow/ComponentRowSingle'));
  });
});
var WalletCardGridContainer = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/WalletCards/WalletCardGridContainer'));
  });
});
var WalletRowListContainer = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/WalletRows/WalletRowListContainer'));
  });
});
var DualFluidHeaderFixedContentLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/DualFluidHeaderFixContent/DualFluidHeaderFixedContentLayout'));
  });
});
var MarketDataCardsContainer = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/MarketDataCardsComponent/MarketDataCardsContainer'));
  });
});
var RetailBuySellLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/BuySellAltLayout/BuySellAltLayout'));
  });
});
// const ConvertLayout = load(() =>
//   import('../layouts/ConvertLayout/ConvertLayout')
// );
var MarketOverviewLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/MarketOverviewLayout/MarketOverviewLayout'));
  });
});
var PageFooterComponent = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/PageFooter/PageFooterComponent'));
  });
});
var WalletDetailsLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/WalletDetailsLayout/WalletDetailsLayout'));
  });
});

// this.t('Dashboard')
// this.t('Exchange')
// this.t('Buy & Sell')
// this.t('Wallets')
// this.t('User Settings')
var mainNavOptions = exports.mainNavOptions = {
  mainNavItems: [{
    text: 'Dashboard',
    icon: 'dashboard',
    path: '/dashboard'
  }, {
    text: 'Exchange',
    icon: 'trading',
    path: '/exchange'
  }, {
    text: 'Buy & Sell',
    icon: 'buy-sell',
    path: '/buy-sell'
  }, {
    text: 'Convert',
    icon: 'exchange',
    path: '/convert'
  }, {
    text: 'Wallets',
    icon: 'wallet',
    path: '/wallets'
  }, {
    text: 'User Settings',
    icon: 'user-settings',
    path: '/settings/profile'
  }],
  settingsPath: '/settings/profile'
};
// this.t('Your Snapshot')
// this.t('Market Data')
var subNavItems = exports.subNavItems = [{
  text: 'Your Snapshot',
  path: '/dashboard'
}, {
  text: 'Market Data',
  path: '/dashboard/market-data'
}];
var walletsPath = exports.walletsPath = '/wallets';
var walletDetailPath = exports.walletDetailPath = '/activity';
var routesArray = exports.routesArray = [{
  exact: true,
  path: '/dashboard',
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(DualHeaderDashboardLayout, {
      headerSecondary: /*#__PURE__*/_react["default"].createElement(SubNavComponent, null),
      notificationComponent: /*#__PURE__*/_react["default"].createElement(NotificationsList, null),
      component1: /*#__PURE__*/_react["default"].createElement(MarketOverviewLayout, null),
      component2: /*#__PURE__*/_react["default"].createElement(BalancesListLayout, null),
      component3: /*#__PURE__*/_react["default"].createElement(RecentActivityContainer, {
        filterForSelected: false
      }),
      footer: /*#__PURE__*/_react["default"].createElement(PageFooterComponent, null)
    });
  }
}, {
  path: '/buy-sell',
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(RetailBuySellLayout, {
      footer: /*#__PURE__*/_react["default"].createElement(PageFooterComponent, null)
    });
  }
},
// {
//   path: '/convert',
//   render: () => <ConvertLayout footer={<PageFooterComponent />} />
// },
{
  path: '/exchange/:symbol?',
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(TradingLayout, null);
  }
}, {
  path: '/dashboard/market-data',
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(DualFluidHeaderFixedContentLayout, {
      headerSecondary: /*#__PURE__*/_react["default"].createElement(SubNavComponent, null),
      footer: /*#__PURE__*/_react["default"].createElement(PageFooterComponent, null)
    }, /*#__PURE__*/_react["default"].createElement(ComponentRowSingle, {
      component: /*#__PURE__*/_react["default"].createElement(MarketDataCardsContainer, null)
    }));
  }
}, {
  exact: true,
  path: '/wallets',
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(SingleFluidHeaderFixedContentLayout, {
      footer: /*#__PURE__*/_react["default"].createElement(PageFooterComponent, null)
    }, /*#__PURE__*/_react["default"].createElement(ComponentRowSingle, {
      header: "Funded Accounts",
      component: /*#__PURE__*/_react["default"].createElement(WalletCardGridContainer, {
        detailsLink: walletDetailPath
      })
    }), /*#__PURE__*/_react["default"].createElement(ComponentRowSingle, {
      customClass: "container-with-shadow",
      header: "Unfunded Accounts",
      component: /*#__PURE__*/_react["default"].createElement(WalletRowListContainer, {
        detailsLink: walletDetailPath
      })
    }));
  }
  // this.t('Funded Accounts')
  // this.t('Unfunded Accounts')
}, {
  path: '/activity',
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(FixedLeftFluidLayout, {
      left: [/*#__PURE__*/_react["default"].createElement(WalletDetailsBackButtonComponent, {
        key: "1"
      }), /*#__PURE__*/_react["default"].createElement(BalancesMenuContainer, {
        key: "2"
      })]
    }, /*#__PURE__*/_react["default"].createElement(WalletDetailsLayout, null));
  }
}];